<template>
	<div class="page">
		合同
	</div>
</template>

<style scoped="scoped">

</style>

<script>
	export default {
		name: 'HeTong',
		components: {},
		data() {
			return {}
		},
		created() {
			
		}
	}
</script>
